import { Injectable } from '@angular/core';
import { Router, NavigationExtras } from '@angular/router';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { VehicleDetailsEndpoint } from '@app/services/vehicleDetails/vehicledetails-endpoint.service';
import { VehicleDetailModel } from '@app/models/VehicleDetailModel';

@Injectable()
export class VehicleDetailsService {
    constructor(private router: Router, private http: Http, private vehicledetailsEndpoint: VehicleDetailsEndpoint) {
    }
    getVehicleDetails() {
        return this.vehicledetailsEndpoint.getVehicleDetails();
    }

    updateVehicleDetails(vehicledetail:VehicleDetailModel) {
        return this.vehicledetailsEndpoint.updateVehicleDetails(vehicledetail);
    }

    addVehicleDetails(vehicledetails:VehicleDetailModel) {
        return this.vehicledetailsEndpoint.addVehicleDetails(vehicledetails);
    }

    mappedVehicle(mappingId,cardID)
    {
        return this.vehicledetailsEndpoint.mappedVehicle(mappingId,cardID);
    }
    unMappedVehicle(mappingId,cardID)
    {
        return this.vehicledetailsEndpoint.unMappedVehicle(mappingId,cardID); 
    }

}


// WEBPACK FOOTER //
// ./src/app/services/vehicleDetails/vehicledetails.service.ts